export const Whitebox = ({ whitebox }) => {
    return (
        <div className="whitebox">
            <img src={whitebox} alt="Room" title="Room" />
        </div>
    )
}